import React from 'react';

interface AddCircleIconProps {
  color?: string;
  className?: string;
  width?: number;
  height?: number;
}

const AddCircleIcon: React.FC<AddCircleIconProps> = ({ color = '#22BBE8', className, width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.0046 17.1377V22.9419C15.0046 23.2417 15.1065 23.4931 15.3103 23.696C15.5144 23.8987 15.767 24 16.0682 24C16.3697 24 16.6205 23.8987 16.8206 23.696C17.0205 23.4931 17.1204 23.2417 17.1204 22.9419V17.1377H22.9419C23.2417 17.1377 23.4931 17.0358 23.696 16.832C23.8987 16.6282 24 16.3756 24 16.0741C24 15.7729 23.8987 15.5222 23.696 15.3221C23.4931 15.122 23.2417 15.0219 22.9419 15.0219H17.1204V9.05811C17.1204 8.75832 17.0185 8.50695 16.8147 8.304C16.6109 8.10133 16.3583 8 16.0568 8C15.7556 8 15.505 8.10133 15.3048 8.304C15.1047 8.50695 15.0046 8.75832 15.0046 9.05811V15.0219H9.05811C8.75832 15.0219 8.50695 15.1238 8.304 15.3276C8.10133 15.5316 8 15.7843 8 16.0855C8 16.3869 8.10133 16.6378 8.304 16.8379C8.50695 17.0378 8.75832 17.1377 9.05811 17.1377H15.0046ZM16.0101 32C13.7951 32 11.7172 31.5801 9.77642 30.7402C7.83565 29.9004 6.14119 28.7559 4.69305 27.3069C3.24491 25.8577 2.10063 24.1632 1.26021 22.2236C0.42007 20.2836 0 18.2072 0 15.9941C0 13.7811 0.41993 11.7025 1.25979 9.75832C2.09965 7.8139 3.24407 6.12154 4.69305 4.68126C6.14232 3.24098 7.83677 2.10063 9.77642 1.26021C11.7164 0.42007 13.7928 0 16.0059 0C18.2189 0 20.2975 0.419929 22.2417 1.25979C24.1861 2.09965 25.8785 3.23944 27.3187 4.67916C28.759 6.11888 29.8994 7.81193 30.7398 9.75832C31.5799 11.7047 32 13.7819 32 15.9899C32 18.2049 31.5801 20.2828 30.7402 22.2236C29.9004 24.1644 28.7606 25.8571 27.3208 27.3019C25.8811 28.7467 24.1881 29.8908 22.2417 30.7343C20.2953 31.5781 18.2181 32 16.0101 32Z"
        fill={color}
      />
    </svg>
  );
};

export default AddCircleIcon;
